<div class='container p-3'>
  <div class="page-header">    
      <mat-spinner color="accent" *ngIf="loading"></mat-spinner>    
  </div>
 
  <div class="row">
    <div class="input-group input-group-lg col-sm-8 col-md-8">
      <app-search-box (loading)="loading = $event" (results)="updateResults($event)" [selectedItem]="selectedItem"></app-search-box>
    </div>
  </div>
 
  <div class="row">    
    <p class="primary-color" fxLayoutAlign="center">{{totalFoundMessage}}</p> 
    <app-search-result *ngFor="let result of results" [result]="result" (select)="onSelect($event)"></app-search-result>
  </div>
</div>
